import interceptorAxios from './InterceptorAxios';

const ServicioEmisor={
    
    guardar(objeto){
        return interceptorAxios.post('/emisor/guardar.json',objeto);
    },
    editarInformacionEmisor(objeto){
        return interceptorAxios.post("/emisor/actulizar_informacion_emisor.json",objeto);
    },
    editarCertificadosEmisor(objeto){
        return interceptorAxios.post("/emisor/actualizar_certificados_emisor.json",objeto);
    },
    paginacion(objeto){
        return interceptorAxios.post('/emisor/paginacion.json',objeto);
    },

    buscarEmisores(){
        return interceptorAxios.post('/emisor/buscar_emisores.json'); 
    },

    buscar_emisor_asignado_usuario(){
        return interceptorAxios.post('emisor/emisor_asignado_usuario.json');
    }

}
export default ServicioEmisor;